// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Condensed', 'Roboto Condensed Fallback'","fontStyle":"normal"},"className":"__className_7d980e"};